import { useCommon } from "../composition-functions/common";
import { getGlobalTranslation } from "../i18n";
import { setToastMessage, setToastMessageLoading } from "../util/SweetalertHelper";
import { SmartpricingIntegrationState } from "./enum.smartpricingIntegrationState";

type SetupIntegrationParams = {
  mandantId: number;
  desiredIntegrationState: SmartpricingIntegrationState;
  activate: (value: number | string) => void;
  step: number | string;
};
export async function setupIntegration({
  mandantId,
  activate,
  desiredIntegrationState,
  step,
}: SetupIntegrationParams): Promise<void> {
  setToastMessageLoading();
  try {
    const { putRequest } = useCommon();
    const response = await putRequest({
      path: `/admin/mandants/${mandantId}/smartpricing/settings/desiredIntegrationState`,
      data: JSON.stringify({ state: desiredIntegrationState }),
    });

    if (!response.ok) {
      let errorMessage = getGlobalTranslation({ message: "message.error" });
      const errorResponse = await response.json();
      errorMessage = errorResponse?.message || errorMessage;
      throw new Error(errorMessage);
    }

    setToastMessage({ icon: "success", title: getGlobalTranslation({ message: "message.recordSaved" }) });
    activate(step);
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : getGlobalTranslation({ message: "message.error" });
    setToastMessage({ icon: "error", title: errorMessage });
    throw error;
  }
}
